var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"os-page scroll-view"},[_c('div',{staticClass:"os-page__content"},[_c('h2',[_vm._v("Sorry, this website is optimized for iPhone users only.")]),_c('p',[_vm._v("To access the full experience, please visit us from an iPhone device. Thank you for your understanding!")])])])
}]

export { render, staticRenderFns }